export const COPY = {
  header: {
    cart: (count: number) => `Корзина, товаров: ${count}`,
    // Подписи шагов живут в SEGMENTS рядом с самим маршрутом: там их
    // видно вместе с составом шага, и они не расходятся при правках.
    quick: {
      artists: 'Артисты',
      catalog: 'Каталог',
    },
  },

  artists: {
    title: 'Мерч артистов',
  },

  catalog: {
    title: 'Каталог',
  },

  prints: {
    title: 'Каталог принтов',
    constructor: 'Собери сам',
  },

  product: {
    title: 'Каталог',
    addToCart: 'Оформить заказ',
    view: 'Вид',
    prevImage: 'Предыдущее изображение',
    nextImage: 'Следующее изображение',
  },

  builder: {
    title: 'Шаг 1',
    subtitle: 'Выбери цвет и размер для основы',
    hint: 'Для перехода ко второму шагу нужно выбрать концепт будущего мерча',
    library: 'Выбери принт',
    next: 'Далее',
    // Подпись главного действия в нижней панели: она отвечает на вопрос
    // «что произойдёт», а не «куда я иду».
    action: 'Поставить принт',
  },

  library: {
    title: 'Шаг 2',
    subtitle: 'Выбери цвет и размер для основы',
    hint: 'Для перехода ко второму шагу нужно выбрать принт',
    action: 'Разместить принт',
  },

  placement: {
    title: 'Шаг 3',
    subtitle: 'Выбери расположение принта',
    hint: 'Двигай поле, растягивай и меняй пропорции курсором так, как ты хотел бы расположить принт. Наш редактор подстроит изображение под выделенную зону',
    add: 'Добавить принт',
    remove: 'Убрать принт',
    flip: 'Отразить принт',
    resize: 'Размер принта',
    tilt: 'Наклон принта',
    noPrints: 'У этого артиста пока нет принтов',
    empty: 'Выбери принт на изделии',
    action: 'Посмотреть результат',
  },

  result: {
    title: 'Итог',
    subtitle: 'Оцени свой готовый дизайн',
    hint: 'Посмотри внимательно и проверь расположение принта',
    addToCart: 'Оформить заказ',
  },

  cart: {
    title: 'Корзина',
    empty: 'Корзина пуста',
    close: 'Закрыть',
    remove: 'Удалить',
    clear: 'Очистить корзину',
    size: 'Размер',
    total: 'Итого:',
    checkout: 'Оформить заказ',
    decrease: 'Уменьшить количество',
    increase: 'Увеличить количество',
  },

  order: {
    title: 'Оформление заказа',
    goods: 'Товары',
    total: 'Итого:',
    fields: {
      fullName: 'ФИО получателя',
      email: 'Эл. почта',
      phone: 'Телефон',
      comment: 'Комментарий к заказу',
      address: 'Укажи свой адрес\nи мы подберём ближайший пункт выдачи',
    },
    errors: {
      fullName: 'Укажи имя и фамилию буквами',
      email: 'Проверь адрес почты',
      phone: 'Номер должен содержать 11 цифр',
      address: 'Укажи город, улицу и номер дома',
      network: 'Не удалось отправить заказ. Проверь связь и попробуй ещё раз.',
    },
    submit: 'Оформить заказ',
    submitting: 'Отправляем',
    done: {
      title: 'Спасибо за заказ',
      number: (value: number) => `Заказ № ${value}`,
      text: 'Мы получили заявку и свяжемся с тобой для подтверждения.',
      lead: 'Срок изготовления — от 3 до 7 рабочих дней.',
    },
  },

  common: {
    loading: 'Загружаем каталог…',
  },

  error: {
    title: 'Что-то пошло не так',
    text: 'Конструктор не смог отрисовать этот экран. Обнови страницу — собранный заказ сохранится.',
    retry: 'Обновить',
  },

  guide: {
    title: 'Размерная сетка',
    size: 'Размер',
    chest: 'Обхват груди, см',
    length: 'Длина, см',
    sleeve: 'Длина рукава, см',
    note: 'Мерки указаны для изделия, а не для тела. Если между размерами — бери больший: крой свободный.',
  },

  options: {
    total: 'Итого',
    color: 'Выбери цвет',
    size: 'Выбери размер',
    sizeQty: 'Размеры и количество',
    guide: 'Размерная сетка',
    // Сводка выбора снаружи окна на узком экране.
    sizeEmpty: 'Не выбран',
    sizePick: 'Выбрать размер',
    sizeDone: 'Готово',
  },

  footer: {
    powered: 'powered by сияй',
    demo: ' · демо-каталог',
  },

  nav: {
    back: 'Назад',
    next: 'Далее',
  },

  siteMenu: {
    title: 'Меню сайта',
    open: 'Открыть меню сайта',
  },

  sides: {
    front: 'спереди',
    back: 'сзади',
  },
} as const;
